import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar } from './snackbarSlice';
import {
  createCategory,
  editCategory,
} from '../../ApiServices/CategoriesService';
import { t } from 'i18next';
import { handleResponse } from '../../ApiServices/ApiHandler';

export const initialState = {
  value: { totalCount: -1, data: [{}] },
  loading: false,
  error: null,
  rowsPerPage: 10,
  pageNo: 0,
  selectedValue: null,
  message: null,
};

const categorySlice = createSlice({
  name: 'category',
  initialState: initialState,
  reducers: {
    clearCategoryState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.message = null;
    },
  },
  // extraReducers: (builder) => {
  //   builder.addCase(fetchCategories.fulfilled, (state: any, action: any) => {
  //     state.error = initialState.error;
  //     state.loading = initialState.loading;
  //     state.selectedValue = initialState.selectedValue;
  //     state.value = action?.payload?.data;
  //     state.pageNo = action?.meta?.arg?.page;
  //     state.rowsPerPage = action?.meta?.arg?.limit;
  //   });
  //   builder.addCase(fetchCategories.rejected, (state: any, action: any) => {
  //     state.loading = initialState.loading;
  //     state.error = action?.payload?.data;
  //   });
  // },
});

export const categoryState = (state: RootState) => state?.category;
export const { clearCategoryState } = categorySlice.actions;
export default categorySlice.reducer;

// export const fetchCategories = createAsyncThunk(
//   'category/fetchCategories',
//   async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
//     try {
//       dispatch(showLoader({ message: t('FETCHING_CATEGORIES') }));
//       return fulfillWithValue(await getCategoriesByPage(payload));
//     } catch (error) {
//       dispatch(showErrorSnackbar({ message: error }));
//       return rejectWithValue(error);
//     } finally {
//       dispatch(hideLoader());
//     }
//   }
// );

export const addCategory = createAsyncThunk(
  'category/addCategory',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('ADDING_NEW_CATEGORY_DETAILS') }));
      let response = await createCategory(payload);
      return await handleResponse(
        response,
        fulfillWithValue,
        rejectWithValue,
        dispatch
      );
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const modifyCategory = createAsyncThunk(
  'category/modifyCategory',
  async (payload: any, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      dispatch(showLoader({ message: t('UPDATE_CATEGORY_DETAILS') }));
      let response = await editCategory(payload);
      return await handleResponse(
        response,
        fulfillWithValue,
        rejectWithValue,
        dispatch
      );
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
